import { createAsyncThunk } from '@reduxjs/toolkit';
//api
import * as serviceAPI from 'api/service';
// actions
import * as actions from 'slices/service';

/**
 * @dispatch 적립금 쿠폰 매칭
 * @param {object} props
 * @param {number} props.couponNumber 쿠폰 번호
 */
export const postCheckCoupon = createAsyncThunk(
  'service/postCheckCoupon',
  async ({ couponNumber }, { dispatch }) => {
    return serviceAPI
      .postCheckCoupon({ couponNumber })
      .then(res => {
        dispatch(actions.updateCoupon(res));
        return res;
      })
      .catch(() => {
        return false;
      });
  },
);

/**
 * @dispatch 공지사항 추가
 * @param {object} props
 * @param {number} props.page 페이지 카운트
 */
export const getNoticeList = createAsyncThunk(
  'service/getNoticeList',
  async ({ page = 1 }, { dispatch }) => {
    return serviceAPI
      .getNotice(page)
      .then(res => {
        dispatch(actions.pushNoticeList(res.list));
        return res.list;
      })
      .catch(() => {
        return false;
      });
  },
);
